import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

/**
 * Brands that answered the plan choice shown on their first dashboard, so it is
 * offered once. A per-browser UI memory like the companion banner dismissal:
 * the plan itself is the server's, and the brand can change it from settings.
 */
type PlanChoiceStore = {
  decidedAtByBrandId: Record<string, string>;
  markDecided: (brandId: string) => void;
};

export const usePlanChoiceStore = create<PlanChoiceStore>()(
  devtools(
    persist(
      (set, get) => ({
        decidedAtByBrandId: {},

        markDecided: (brandId) => {
          if (get().decidedAtByBrandId[brandId]) return;

          set((state) => ({
            decidedAtByBrandId: {
              ...state.decidedAtByBrandId,
              [brandId]: new Date().toISOString(),
            },
          }));
        },
      }),
      {
        name: 'plan-choice-storage',
        partialize: (state) => ({ decidedAtByBrandId: state.decidedAtByBrandId }),
      }
    ),
    { name: 'PlanChoiceStore' }
  )
);
